import { tipTapBaseExtensions } from '@lessonup/pins-shared';
import { JSONContent, useEditor } from '@tiptap/react';
import React from 'react';

interface TiptapViewerProps {
  content?: JSONContent | null;
}

// proseMirror adds a <br> to empty paragraphs in the editor and teachers expect the same behavior in the viewer
function addBreaksToEmptyParagraphs(html: string): string {
  return html.replace(/<p><\/p>/g, '<p><br></p>');
}

const defaultContent = '<p><br></p>';

export const TiptapViewer: React.FC<TiptapViewerProps> = ({ content }) => {
  const editor = useEditor(
    {
      content: content ?? defaultContent,
      extensions: tipTapBaseExtensions,
    },
    [content]
  );

  return <div dangerouslySetInnerHTML={{ __html: addBreaksToEmptyParagraphs(editor?.getHTML() ?? defaultContent) }} />;
};
